module.exports = __webpack_public_path__ + "img/logo_navbar.bd642cd3.png";